import { FC } from "react";
import type { SetEntry } from "../helper";
import { Text } from "components/common/Text";

type ScoreboardProps = {
  homeName: string;
  awayName: string;
  setEntries: SetEntry[];
  totals: [number, number];
  points: [number, number];
};

export const TennisScoreboard: FC<ScoreboardProps> = ({
  homeName,
  awayName,
  setEntries,
  totals,
  points,
}) => {
  return (
    <table className="w-full border border-solid rounded-[1vw] border-border text-lighterGray bg-darkestBlue">
      <thead className="bg-darkestBlue">
        <tr className="bg-darkGray">
          <th className="border-b border-border px-[1.3vw] py-[0.9vw] text-left font-bold uppercase text-lighterGray">
            <Text variant="chartTitle">Player(s)</Text>
          </th>
          {setEntries.map(({ key, label }) => (
            <th
              key={key}
              className="border-b border-border px-[1vw] py-[0.9vw] text-center font-bold uppercase text-lighterGray"
            >
              <Text variant="chartTitle">{label}</Text>
            </th>
          ))}
          <th className="border-b border-border px-[1vw] py-[0.9vw] text-center font-bold uppercase text-lighterGray">
            <Text variant="chartTitle">Total Sets</Text>
          </th>
          <th className="border-b border-border px-[1vw] py-[0.9vw] text-center font-bold uppercase text-lighterGray">
            <Text variant="chartTitle">Current Game</Text>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td className="whitespace-nowrap px-[1.3vw] py-[1vw] text-left font-bold text-white border-b border-border">
            <Text variant="chartValue">{homeName}</Text>
          </td>
          {setEntries.map(({ key, pair }) => (
            <td
              key={`home-${key}`}
              className="px-[1vw] py-[1vw] text-center text-white border-b border-border"
            >
              <Text variant="chartValue">{pair[0]}</Text>
            </td>
          ))}
          <td className="px-[1vw] py-[1vw] text-center font-extrabold text-yellow border-b border-border">
            <Text variant="chartValue">{totals[0]}</Text>
          </td>
          <td className="px-[1vw] py-[1vw] text-center font-bold text-green border-b border-border">
            <Text variant="chartValue">{points[0]}</Text>
          </td>
        </tr>
        <tr>
          <td className="whitespace-nowrap px-[1.3vw] py-[1vw] text-left font-bold text-white">
            <Text variant="chartValue">{awayName}</Text>
          </td>
          {setEntries.map(({ key, pair }) => (
            <td
              key={`away-${key}`}
              className="px-[1vw] py-[1vw] text-center text-white"
            >
              <Text variant="chartValue">{pair[1]}</Text>
            </td>
          ))}
          <td className="px-[1vw] py-[1vw] text-center font-extrabold text-yellow">
            <Text variant="chartValue">{totals[1]}</Text>
          </td>
          <td className="px-[1vw] py-[1vw] text-center font-bold text-green">
            <Text variant="chartValue">{points[1]}</Text>
          </td>
        </tr>
      </tbody>
    </table>
  );
};
